import * as ChartViewControllerUI from './ChartViewControllerUI';
import { useAppDispatch } from '../../../redux/hooks';
import { setChartSettingsTableSettingsAction } from '../../../redux/slices/analyses';
import ChartViewControllerItem from './ChartViewControllerItem';
import { ChartViewOptions } from '../../../redux/utils/chartSettings';

interface IProps {
  analysisId: string;
  value: ChartViewOptions;
}

export default ({ analysisId, value }: IProps) => {
  const dispatch = useAppDispatch();

  const handleChangeView = (view: ChartViewOptions) => {
    dispatch(
      setChartSettingsTableSettingsAction({
        analysisId,
        tableSettings: {
          chartView: view,
        },
      }),
    );
  };

  return (
    <ChartViewControllerUI.Container>
      <ChartViewControllerUI.CenterLine layout="horizontal" size="full" />
      <ChartViewControllerUI.Panel>
        <ChartViewControllerItem
          iconName="square-split-vertical"
          content={'Chart and Table'}
          onClick={() => handleChangeView(ChartViewOptions.ChartAndTable)}
          isActive={value === ChartViewOptions.ChartAndTable}
        />
        <ChartViewControllerItem
          iconName="square-split-vertical-bottom"
          content={'Chart'}
          onClick={() => handleChangeView(ChartViewOptions.Chart)}
          isActive={value === ChartViewOptions.Chart}
        />
        <ChartViewControllerItem
          iconName="square-split-vertical-top"
          content={'Table'}
          onClick={() => handleChangeView(ChartViewOptions.Table)}
          isActive={value === ChartViewOptions.Table}
        />
      </ChartViewControllerUI.Panel>
    </ChartViewControllerUI.Container>
  );
};
